import moment from "moment";
import _ from "lodash";

import apiUrl from "api-url";
import buildSearchBarState from "components/search-bar/SearchBarStateBuilder";
import { PaginationType } from "components/search-bar/enums.utils";

import buildFetchDuck from "vendor/signal-utils/build-fetch-duck";

import {
  SEARCH_CATEGORIES,
  FILTERS,
} from "pages/partview/components/search/DealerPartView.searchOptions";
import { packageDetailsWithFilteredExceptions } from "pages/partview/utils/exceptions.utils";
import { updatedWatchedPackages } from "pages/partview/utils/watchedPackageUtils";
import { transformSearchResponse } from "../utils/transformSearchResponse";

const STORE_MOUNT_POINT = "dealerPartViewSearch";

// PV-2417: Need to hide Destination filter if has only one location or less.
const destinationLocationsDuck = buildFetchDuck(
  STORE_MOUNT_POINT,
  "destinationLocations",
);

const watchedPackageListDuck = buildFetchDuck(
  STORE_MOUNT_POINT,
  "watchedPackageList",
);

export const fetchDestinationCountForFiliterVisibility =
  (selectedFvOrgId) => (dispatch) => {
    const params = { pageNumber: 0, pageSize: 1 };
    if (selectedFvOrgId) {
      params.fvOrgId = selectedFvOrgId;
    }
    const url = apiUrl("/partview/app/list/destination");
    dispatch(
      destinationLocationsDuck.fetch(url, {
        // Passing pagination params so we get `meta`.
        params,
      }),
    );
  };

export const getShowDestinationFilter = (state) => {
  const duckState = destinationLocationsDuck.selectors.getData(state);
  return duckState?.data?.meta?.totalCount > 1 ?? false;
};

// SearchBarStateBuilder need 'solutionId' as first parameter,
// but not required here therefore named it _ignored_solutionId
const entitiesUrl = (_ignored_solutionId, queryString) => {
  return apiUrl(`/partview/app/opensearch/search?status=active&${queryString}`);
};

const getSelectedFvOrgId = (state) => {
  return (
    SearchBarState.selectors.getSearchFilters(state)?.fvOrgId?.[0]?.value ??
    null
  );
};

const fetchWatchedPackageIDs = () => (dispatch) => {
  let url = apiUrl(`partview/app/package-container-watch`);
  dispatch(watchedPackageListDuck.fetch(url));
};

const fetchSearch = (
  queryString = "",
  _ignored_solutionId,
  duck,
  dispatch,
  state,
  preventRedirect,
) => {
  const url = entitiesUrl(null, queryString);
  const config = {
    headers: {
      "x-time-zone": moment.tz.guess(),
      Accept: "application/json;",
    },
  };

  // Remove 'Damage' exception from Active Exception and Exceptions for dealer
  const transform = (data) => {
    let transformedData = transformSearchResponse(data); // OPEN SEARCH
    let packageDetails = transformedData?.data?.map((result) => {
      return packageDetailsWithFilteredExceptions(result);
    });
    return { ...data, data: packageDetails };
  };

  // Fetch the search
  dispatch(duck.fetch(url, config, transform));
  dispatch(fetchWatchedPackageIDs());

  // Redirect to PartView search page
  // Prevent redirect if needed
  if (!preventRedirect) {
    dispatch({ type: "DEALER_PARTVIEW_SEARCH" });
  }
};

//selectors
const getWatchedSearchResults = (state) => {
  const searchWatchedPackage = state[STORE_MOUNT_POINT]?.data?.data;
  const duckState =
    watchedPackageListDuck.selectors.getData(state)?.data
      ?.userWatchedContainerIds;
  const result = updatedWatchedPackages(searchWatchedPackage, duckState);
  return result ?? [];
};

// Reducer

const SearchBarState = buildSearchBarState(
  STORE_MOUNT_POINT,
  SEARCH_CATEGORIES,
  FILTERS,
  fetchSearch,
  [destinationLocationsDuck.reducer, watchedPackageListDuck.reducer],
  { defaultSort: "destinationEta", reverseSort: false },
  20,
  PaginationType.OPEN_SEARCH,
);

SearchBarState.actionCreators.exportSearch = _.partial(
  SearchBarState.actionCreators.exportEntities,
  entitiesUrl,
  null,
  { headers: { Accept: "text/csv;version=full" } },
  "part-view-search-results",
);

SearchBarState.selectors = {
  ...SearchBarState.selectors,
  getSelectedFvOrgId,
  getWatchedSearchResults,
};

export default SearchBarState;
